import React from "react";
import { Form, Segment } from "semantic-ui-react";
import ReactHtmlParser from "react-html-parser";
import PropTypes from "prop-types";

/**
 * Email subject and preview component
 */
const EmailPreview = ({ subject, previewHtml }) => {
  return (
    <>
      <Form.Field>
        <label>Subject</label>
        <Segment>{subject}</Segment>
      </Form.Field>
      <Form.Field>
        <label>Preview</label>
        <Segment>{ReactHtmlParser(previewHtml)}</Segment>
      </Form.Field>
    </>
  );
};

EmailPreview.propTypes = {
  subject: PropTypes.string,
  previewHtml: PropTypes.string,
};

export default EmailPreview;
